interface CheckIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const CheckIcon: React.FC<CheckIconProps> = ({
  size = 24,
  color = "white",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "16"}
      height={size ?? "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.0405 3.29289C14.431 3.68342 14.431 4.31658 14.0405 4.70711L6.70719 12.0404C6.31666 12.431 5.6835 12.431 5.29297 12.0404L1.95964 8.70711C1.56912 8.31658 1.56912 7.68342 1.95964 7.29289C2.35017 6.90237 2.98333 6.90237 3.37385 7.29289L6.00008 9.91912L12.6263 3.29289C13.0168 2.90237 13.65 2.90237 14.0405 3.29289Z"
        fill={color ?? "white"}
      />
    </svg>
  );
};

export default CheckIcon;
